import { Button, Chip, Stack, TextField } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import { DataTable, DateText, PageHeader, StatusChip, useListParams } from "../components";
import help from "./HELP.md?raw";
import { useTenants, type Tenant } from "./useData";

export function Tenants() {
  const navigate = useNavigate();
  const [params, setParams] = useListParams({ ordering: "-created_at" });
  const tenants = useTenants(params);
  const columns: GridColDef<Tenant>[] = [
    { field: "name", headerName: "Organization", flex: 1, renderCell: (p) => <Stack direction="row" spacing={1} alignItems="center"><span>{p.value as string}</span><Chip label={p.row.slug} size="small" variant="outlined" /></Stack> },
    { field: "status", headerName: "Status", width: 110, renderCell: (p) => <StatusChip status={p.value as string} /> },
    { field: "plan", headerName: "Plan", width: 160, sortable: false, valueGetter: (_v, row) => `${row.subscription.plan ?? "—"} · ${row.subscription.status}` },
    { field: "trial", headerName: "Trial", width: 80, sortable: false, valueGetter: (_v, row) => row.subscription.trial_days_left ?? "" },
    { field: "member_count", headerName: "Members", width: 90, sortable: false },
    { field: "site_count", headerName: "Sites", width: 80, sortable: false },
    { field: "owners", headerName: "Owners", flex: 1, sortable: false, valueGetter: (v) => (v as string[]).join(", ") },
    { field: "created_at", headerName: "Signed up", width: 130, renderCell: (p) => <DateText value={p.value as string} /> },
  ];
  return (
    <>
      <PageHeader help={help} title="Organizations" subtitle="Every customer workspace" crumbs={[{ label: "Console" }, { label: "Organizations" }]}
        actions={<Button variant="outlined" onClick={() => navigate("/console/metrics")}>SaaS metrics</Button>} />
      <DataTable viewKey="console.tenants" columns={columns} data={tenants.data} isLoading={tenants.isLoading} params={params} onParamsChange={setParams}
        onRowClick={(row) => navigate(`/console/organizations/${row.id}`)}
        filters={<TextField select size="small" label="Status" value={String(params.status ?? "")} onChange={(e) => setParams({ ...params, status: e.target.value, page: 1 })} slotProps={{ select: { native: true } }} sx={{ width: 150 }}>
          <option value="">All</option>{["trial", "active", "past_due", "suspended", "closed"].map((s) => <option key={s} value={s}>{s}</option>)}
        </TextField>} />
    </>
  );
}
